import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

const ListTable = ({ actionButton, label, data = [] }) => {
  if (!Array.isArray(data) || data.length === 0) {
    return <Typography>No data available</Typography>;
  }

  const columns = Object.keys(data[0]);
  console.log(actionButton);

  return (
    <>
      <div className="flex items-center justify-between w-full mb-2">
        <Typography fontWeight="medium">{label}</Typography>
        {/* Actions */}
        {actionButton ?? null}
      </div>

      <TableContainer sx={{ mt: 2 }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              {columns.map((key) => (
                <TableCell
                  key={key}
                  sx={{ fontWeight: "bold", textTransform: "capitalize" }}
                >
                  {key.replaceAll("_", " ")}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((row, rowIdx) => (
              <TableRow key={rowIdx}>
                {columns.map((key) => (
                  <TableCell className="py-4" key={key}>
                    {Array.isArray(row[key])
                      ? row[key].join(", ")
                      : row[key] != null
                      ? row[key]
                      : "-"}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default ListTable;
